// 1:1 aus webapp/projects/club-member-registration/src/environment.base.ts.
//
// Was dort NICHT steht und deshalb hier fehlt: titleSuffix, privacyUrl, platformOrganization,
// firebase, organization/federationIds, pushChannelName, Logo-Dateinamen, appUrlRegex. Der
// Titel-Suffix wird zur Laufzeit gesetzt (`pageTitleService.setTitleSuffix('Anmeldung')` in der
// Wizard-Shell), nicht aus der Config gelesen (APP_MIGRATE.md §7 „environment.base.ts → config.ts").
//
// `apiPath` ist generisch (`/apis/clubity`, wie club-member-app) — der Katalogname fuer
// /apis/translation/{appName}/messages ist deshalb die appId, nicht das apiPath-Segment.
export const APP_CONFIG = {
    appId: 'club_member_registration',
    appType: 'end_user',
    institutionType: 'club',
    apiPath: '/apis/clubity',
    appVersion: '15.0.0',
    sentryEnvironment: 'club-member-registration',
} as const;
